import React, { useState } from "react";
import { CiEdit } from "react-icons/ci";
import VisareturnfromprojectPopUp from "./visareturnPoPup";

const titles = [
  "VISA BLOCK NO",
  "VISA PROFESSION",
  "NATIONALITY",
  "ALLOCATED",
  "STAMPED",
  "BALANCE",
  "ACTION",
];

export default function TableAllocatedVisaDetails({ VisaDetails }) {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [propData, setPropData] = useState();
  const [updateData, setUpdateData] = useState(VisaDetails);

  const handleClick = (data) => {
    setPropData(data);
    setPopUpOpen(true);
  };

  if (!VisaDetails?.length) return null;

  return (
    <>
      {popUpOpen && (
        <VisareturnfromprojectPopUp
          popUpOpen={popUpOpen}
          setPopUpOpen={setPopUpOpen}
          propData={propData}
          updateData={updateData}
        />
      )}

      <div className="overflow-x-auto bg-white rounded-lg shadow max-h-[40vh] mb-4">
        <table className="min-w-full">
          <thead className="sticky top-0 z-20">
            <tr>
              {titles.map((t, i) => (
                <th
                  key={i}
                  style={{ backgroundColor: '#f9fafb' }}
                  className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap"
                >
                  {t}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {VisaDetails.map((list, index) => (
              <tr key={index} className="border-b-[1.5px] border-slate-100 hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-base text-gray-700">
                  {list?.vrf_visa?.visa_block_number || "-"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-base text-gray-700">
                  {list?.vrf_visa?.visa_profession?.name || "-"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-base text-gray-700">
                  {list?.vrf_visa?.nationality?.name || "-"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-base text-gray-700">
                  {list?.allocated}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-base text-gray-700">
                  {list?.stamped}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-base text-gray-700">
                  {list?.balance}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <button
                    className="p-1 px-2 rounded-md ring-1 ring-slate-600"
                    onClick={() => handleClick(list)}
                  >
                    <CiEdit size="1.4rem" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
